import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import Dropzone from 'react-dropzone';
import { FILEPICKER_KEY } from '../constants';
import actions from '../redux/actions';

class AvatarUploader extends Component {
  filepicker = null;

  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: '',
      dropzoneActive: false,
    };
  }

  componentDidMount() {
    this.filepicker = require('filepicker-js');
    this.filepicker.setKey(FILEPICKER_KEY);
  }

  componentDidUpdate() {
    const { image } = this.props;

    if (this.state.imagePreviewUrl !== image) {
      this.setState({ imagePreviewUrl: image });
    }
  }

  onDragEnter() {
    this.setState({
      dropzoneActive: true,
    });
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false,
    });
  }

  onDrop(files, rejected) {
    this.setState({
      dropzoneActive: false,
    });

    this.props.hideAlert();
    if (rejected.length) {
      this.props.alert(
        'error',
        'Please upload only .jpeg and .png image files.'
      );
      return;
    }

    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState({
        imagePreviewUrl: reader.result,
      });
    };

    reader.readAsDataURL(files[0]);

    this.filepicker.store(
      files[0],
      (FPFile) => {
        this.setState({
          imagePreviewUrl: FPFile.url,
        });
        this.props.onUpload(FPFile);
        this.props.alert('success', 'Upload successful!');
      },
      (FPError) => {
        console.error(FPError);
        this.props.alert(
          'error',
          'Oops! Your upload has failed. Please try again.'
        );
      }
    );
  }

  _handleClick(e) {
    e.preventDefault();
    this.props.hideAlert();

    if (this.props.readOnly) {
      return;
    }

    this.filepicker.pick(
      {
        extensions: ['.png', '.jpg', '.jpeg'],
        container: 'modal',
        openTo: 'COMPUTER',
        maxSize: 1024 * 1024,
      },
      (FPFile) => {
        this.setState({
          imagePreviewUrl: FPFile.url,
        });
        this.props.onUpload(FPFile);
        this.props.alert('success', 'Upload success!');
      },
      (FPError) => {
        console.error(FPError);
        this.props.alert('error', 'Upload failed!');
      }
    );
  }

  _handleImageRemove(e) {
    e.preventDefault();

    this.setState({
      file: null,
      imagePreviewUrl: '',
    });

    this.props.onUpload(null);
  }

  render() {
    const { readOnly } = this.props;
    const { imagePreviewUrl, dropzoneActive } = this.state;
    const size = this.props.size ? parseFloat(this.props.size) : null;
    const dropStyle = {
      width: '100%',
      height: '100%',
      border: 0,
    };

    return (
      <div className="avatar-upload">
        <div className="img-wrapper" style={{ width: size, height: size }}>
          {imagePreviewUrl && !readOnly ? (
            <a className="remove" onClick={(e) => this._handleImageRemove(e)}>
              <FontAwesome name="close" />
            </a>
          ) : null}
          <div
            className={`img-preview ${dropzoneActive ? 'active' : ''} ${
              readOnly ? 'read-only' : ''
            }`}
            onClick={(e) => this._handleClick(e)}
            style={{
              width: size,
              height: size,
              backgroundImage: `url(${imagePreviewUrl})`,
            }}
          >
            {imagePreviewUrl ? null : (
              <Dropzone
                accept="image/jpeg, image/png"
                multiple={false}
                disableClick={true}
                style={dropStyle}
                onDrop={(files, rejected) => this.onDrop(files, rejected)}
                onDragEnter={() => this.onDragEnter()}
                onDragLeave={() => this.onDragLeave()}
              >
                <FontAwesome name="plus" />
                {!readOnly && this.props.children}
              </Dropzone>
            )}
          </div>
        </div>
      </div>
    );
  }
}

AvatarUploader.defaultProps = {
  readOnly: false,
};

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(null, mapDispatchToProps)(AvatarUploader);



// WEBPACK FOOTER //
// src/components/AvatarUploader.jsx